var _line, _line2, _line3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 5.2729,
    x2: 12,
    y2: 5.2729,
    stroke: "#4B4B4B",
    strokeWidth: 1.09091
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 8.54585,
    x2: 12,
    y2: 8.54585,
    stroke: "#4B4B4B",
    strokeWidth: 1.09091
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 11.8183,
    x2: 12,
    y2: 11.8183,
    stroke: "#4B4B4B",
    strokeWidth: 1.09091
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36357 3.36377L6.27266 0.818315L8.18175 3.36377H4.36357Z",
    fill: "#4B4B4B",
    stroke: "#4B4B4B",
    strokeWidth: 0.545455
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18184 13.7275L6.27275 16.273L4.36366 13.7275L8.18184 13.7275Z",
    fill: "#4B4B4B",
    stroke: "#4B4B4B",
    strokeWidth: 0.545455
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/dragIcon.b669e0d9b6ffb0a945720d354e35b947.svg";
export { ForwardRef as ReactComponent };